module.exports = __webpack_public_path__ + "media/images/hono32-de923e51596b6c946602070fed8af503.png";